<app-header></app-header>
<div class="section">
  <div class="companyDetails">
    <div class="iframeContainer">
      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15936.790812718982!2d101.5651806!3d3.0416138!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9920e47dca802a68!2sLine%20Clear%20Express%20HQ!5e0!3m2!1sen!2smy!4v1619966643681!5m2!1sen!2smy" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
    </div>
    <div class="contactUsDetails">
      <h4>Line Clear Express & Logistics Sdn Bhd</h4>

      <p class="contactUsDetails-title">Semenanjung, Sabah & Sarawak</p>
      <p class="contactUsDetails-content">8.30am - 6.30pm (Monday - Friday)<br/>
        8.30am - 12.30pm (Saturday)</p>
        
      <p class="contactUsDetails-title">Kelantan & Terangganu</p>
      <p class="contactUsDetails-content">8.30am - 6.30pm (Sunday - Thursday)<br/>
        8.30am - 12.30pm (Saturday)</p>

      <p class="contactUsDetails-title">Customer Service</p>
      <p class="contactUsDetails-content">Phone : 016-501 5050<br/>
        Fax : 03-7890 3536<br/>
        Email: customersupport@lineclearexpress.com</p>
        
      <p class="contactUsDetails-title">eCommerce</p>
      <p class="contactUsDetails-content">Phone: 016-207 9450<br/>
        Email: ebiz@lineclearexpress.com</p>  
    </div>
  </div>
  <div class="contactUsForm">
    <div class="container-fluid">
          <div class="row g-0 ">
            <select class="form-control input-lg topicSelection"
            #mySelect
            (change)='selectedOpt(mySelect.value)' style="width: 100% !important">
                <option value="default" selected disabled hidden>Select a topic</option>
                <option value="parcel">Issue with parcels</option>
                <option value="lost">Reporting a lost or damaged item</option>
                <option value="accopen">Corporate account opening</option>
                <option value="crossborder">Cross border enquiry</option>
                <option value="servicepoint">Service point enquiry</option>
                <option value="career">Join our team</option>
            </select>
          </div>

          <div class="row form-pad default g-0" *ngIf="isOpt == 'default'">
            <form class="form-horizontal" role="form">
              <div class="form-group">
              </div>
            </form>
          </div>

          <div class="row form-pad parcel g-0" *ngIf="isOpt == 'parcel'" >
            <form (submit)="sendMail()" class="form-horizontal" role="form" ngNativeValidate>
              <div class="form-group mobile-pad">
                <input type="text" class="form-control input-lg" name="parcelName" [(ngModel)]="parcelName" [(value)]="parcelName" id="parcelName" placeholder="Name" required>
              </div>
              <div class="form-group">
                <input type="email" class="form-control input-lg" name="parcelEmail" [(ngModel)]="parcelEmail" [(value)]="parcelEmail" id="parcelEmail" placeholder="Email" required>
              </div>
              <div class="form-group row" >
                <div class="row-leftColumn">
                  <input type="text" class="form-control input-lg" name="parcelTracker" [(ngModel)]="parcelTracker" [(value)]="parcelTracker" id="parcelTracker" placeholder="Tracking Number" required>
                </div>
                <div class="row-rightColumn">
                  <input type="text" class="form-control input-lg" name="parcelPhone" [(ngModel)]="parcelPhone" [(value)]="parcelPhone" id="parcelPhone" placeholder="Contact Number"required>
                </div>
              </div>
              <div class="form-group ">
                <div class="col-12 ">
                  <label class="btn track-btn input-lg display-flex-center " style="width: 100% !important;padding:0;">
                    <input type="file" id="fileToUpload" name="attachment" class="form-control input-lg">
                    <div id="uploadtitle" style="width: 100%;">Upload Parcel Image</div>
                  </label>
                </div>
              </div>
              <div class="form-group ">
                <div class="col-12 ">
                  <textarea name="parcelMessage" [(ngModel)]="parcelMessage" [(value)]="parcelMessage" id="parcelMessage" placeholder="Description" data-form-field="textarea" class="form-control input-lg descriptionBox"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12 submitButtonContainer">
                  <button type="submit" class="btn btn-default btn-lg track-btn submitButton">Submit</button>
                </div>
              </div>
            </form>
          </div>


          <div class="row form-pad lost g-0" *ngIf="isOpt == 'lost'">
            <form (submit)="sendMail()" class="form-horizontal" role="form" ngNativeValidate>
              <div class="form-group">
                <div class="col-12 mobile-pad">
                  <input type="text" class="form-control input-lg" name="lostName" [(ngModel)]="lostName" [(value)]="lostName" id="lostName" placeholder="Name" required>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12">
                  <input type="email" class="form-control input-lg" name="lostEmail" [(ngModel)]="lostEmail" [(value)]="lostEmail" id="lostEmail" placeholder="Email" required>
                </div>
              </div>
              <div class="form-group row">
                <div class="mobile-pad row-leftColumn">
                  <input type="text" class="form-control input-lg" name="lostTracker" [(ngModel)]="lostTracker" [(value)]="lostTracker" id="lostTracker" placeholder="Tracking Number" required>
                </div>
                <div class="row-rightColumn">
                  <input type="text" class="form-control input-lg" name="lostPhone" [(ngModel)]="lostPhone" [(value)]="lostPhone" id="lostPhone" placeholder="Contact Number" required>
                </div>
              </div>
              <div class="form-group ">
                <div>
                  <label class="btn track-btn input-lg display-flex-center " style="width: 100% !important;padding:0;">
                    <input type="file" id="fileToUpload" name="attachment" class="form-control input-lg">
                    <div id="uploadtitle" style="width: 100% !important">Upload Image of Damage Parcel</div>
                  </label>
                </div>
              </div>
              <div class="form-group ">
                <div class="col-12 ">
                  <textarea name="lostMessage" [(ngModel)]="lostMessage" [(value)]="lostMessage" id="lostMessage" placeholder="Description" data-form-field="textarea" class="form-control input-lg descriptionBox"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12 submitButtonContainer">
                  <button type="submit" class="btn btn-default btn-lg track-btn submitButton">Submit</button>
                </div>
              </div>
            </form>
          </div>


          <div class="row form-pad accopen g-0" *ngIf="isOpt == 'accopen'">
            <form (submit)="sendMail()" class="form-horizontal" role="form" ngNativeValidate>
              <div class="form-group">
                <div class="col-12 mobile-pad">
                  <input type="text" class="form-control input-lg" name="accopenCompName" [(ngModel)]="accopenCompName" [(value)]="accopenCompName" id="accopenCompName" placeholder="Company Name" required>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12">
                  <input type="text" class="form-control input-lg" name="accopenName" [(ngModel)]="accopenName" [(value)]="accopenName" id="accopenName" placeholder="Your Name" required>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12 mobile-pad">
                  <input type="email" class="form-control input-lg" name="accopenEmail" [(ngModel)]="accopenEmail" [(value)]="accopenEmail" id="accopenEmail" placeholder="Email" required>
                </div>
              </div>
              <div class="form-group row">
                <div class="mobile-pad row-leftColumn">
                  <input type="number" class="form-control input-lg" name="accopenParcel" [(ngModel)]="accopenParcel" [(value)]="accopenParcel" id="accopenParcel" placeholder="No. of parcel(s) per month" required>
                </div>
                <div class="row-rightColumn">
                  <input type="text" class="form-control input-lg" name="accopenPhone" [(ngModel)]="accopenPhone" [(value)]="accopenPhone" id="accopenPhone" placeholder="Contact Number" required>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12">
                  <input type="text" class="form-control input-lg addressBox" name="accopenAddress" [(ngModel)]="accopenAddress" [(value)]="accopenAddress" id="accopenAddress" placeholder="Address" required>
                </div>
              </div>
              <div class="form-group ">
                <div class="col-12 ">
                  <textarea name="accopenMessage" [(ngModel)]="accopenMessage" [(value)]="accopenMessage" id="accopenMessage" placeholder="Description" data-form-field="textarea" class="form-control input-lg descriptionBox"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12 submitButtonContainer">
                  <button type="submit" class="btn btn-default btn-lg track-btn submitButton">Submit</button>
                </div>
              </div>
            </form>
          </div>


          <div class="row form-pad crossborder g-0" *ngIf="isOpt == 'crossborder'">
            <form (submit)="sendMail()" class="form-horizontal" role="form" ngNativeValidate>
              <div class="form-group">
                <div class="mobile-pad">
                  <input type="text" class="form-control input-lg" id="crossborderCompName" placeholder="Company Name" 
                  name="crossborderCompName" [(ngModel)]="crossborderCompName" [(value)]="crossborderCompName" required>
                </div>
              </div>
              <div class="form-group">
                <input type="text" class="form-control input-lg" id="crossborderName" placeholder="Your Name"
                  name="crossborderName" [(ngModel)]="crossborderName" [(value)]="crossborderName" required>
              </div>
              <div class="form-group">
                <input type="email" class="form-control input-lg" id="crossborderEmail" placeholder="Email"
                name="crossborderEmail" [(ngModel)]="crossborderEmail" [(value)]="crossborderEmail" required>
              </div>
              <div class="form-group row">
                <div class="mobile-pad row-leftColumn">
                  <input type="number" class="form-control input-lg" id="crossborderParcel" placeholder="No. of parcel(s) per month"
                  name="crossborderParcel" [(ngModel)]="crossborderParcel" [(value)]="crossborderParcel" required>
                </div>
                <div class="row-rightColumn">
                  <input type="text" class="form-control input-lg" id="crossborderPhone" placeholder="Contact Number"
                  name="crossborderPhone" [(ngModel)]="crossborderPhone" [(value)]="crossborderPhone" required>
                </div>
              </div>
              <div class="form-group">
                <input type="text" class="form-control input-lg addressBox" id="crossborderAddress" placeholder="Address"
                name="crossborderAddress" [(ngModel)]="crossborderAddress" [(value)]="crossborderAddress" required>
              </div>
              <div class="form-group ">
                <div class="col-12 ">
                  <textarea name="crossborderMessage" [(ngModel)]="crossborderMessage" [(value)]="crossborderMessage" id="crossborderMessage" placeholder="Description" data-form-field="textarea" class="form-control input-lg descriptionBox"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12 submitButtonContainer">
                  <button type="submit" class="btn btn-default btn-lg track-btn submitButton">Submit</button>
                </div>
              </div>
            </form>
          </div>


          <div class="row form-pad servicepoint g-0" *ngIf="isOpt == 'servicepoint'">
            <form (submit)="sendMail()" class="form-horizontal" role="form" ngNativeValidate>
              <div class="form-group">
                <div class="mobile-pad">
                  <input type="text" class="form-control input-lg" id="serviceName" placeholder="Name"
                  name="serviceName" [(ngModel)]="serviceName" [(value)]="serviceName" required>
                </div>
              </div>
              <div class="form-group">
                <input type="email" class="form-control input-lg" id="serviceEmail" placeholder="Email"
                name="serviceEmail" [(ngModel)]="serviceEmail" [(value)]="serviceEmail" required>
              </div>
              <div class="form-group">
                <div class=" mobile-pad">
                  <input type="text" class="form-control input-lg" id="servicePhone" placeholder="Contact Number"
                  name="servicePhone" [(ngModel)]="servicePhone" [(value)]="servicePhone" required>
                </div>
              </div>
              <div class="form-group">
                <input type="text" class="form-control input-lg addressBox" id="serviceAddress" placeholder="Address"
                name="serviceAddress" [(ngModel)]="serviceAddress" [(value)]="serviceAddress" required>
              </div>
              <div class="form-group ">
                <div class="col-12 ">
                  <textarea name="serviceMessage" [(ngModel)]="serviceMessage" [(value)]="serviceMessage" id="message" placeholder="Description" data-form-field="textarea" class="form-control input-lg descriptionBox"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12 submitButtonContainer">
                  <button type="submit" class="btn btn-default btn-lg track-btn submitButton">Submit</button>
                </div>
              </div>
            </form>
          </div>


          <div class="row form-pad career g-0" id="career" *ngIf="isOpt == 'career'">
            <form (submit)="sendMail()" class="form-horizontal" role="form" ngNativeValidate>
              <div class="form-group ">
                <div class="mobile-pad">
                  <input type="text" class="form-control input-lg" id="careerName" placeholder="Name"
                  name="careerName" [(ngModel)]="careerName" [(value)]="careerName" required>
                </div>
              </div>
              <div class="form-group ">
                <input type="text" class="form-control input-lg" id="careerPhone" placeholder="Phone Number"
                name="careerPhone" [(ngModel)]="careerPhone" [(value)]="careerPhone" required>
              </div>
              <div class="form-group">
                <div class="mobile-pad">
                  <input type="email" class="form-control input-lg" id="careerEmail" placeholder="Email"
                  name="careerEmail" [(ngModel)]="careerEmail" [(value)]="careerEmail" required>
                </div>
              </div>
              <div class="form-group">
                <div class="">
                  <label class="btn track-btn input-lg display-flex-center " style="width: 100% !important;padding:0;">
                    <input type="file" id="fileToUpload" name="attachment" class="form-control input-lg">
                    <div id="uploadtitle" style="width: 100% !important;">Upload Your Resume</div>
                  </label>
                </div>
              </div>
              <div class="form-group ">
                <div class="col-12 ">
                  <textarea name="careerMessage" [(ngModel)]="careerMessage" [(value)]="careerMessage" required id="careerMessage" placeholder="Description" data-form-field="textarea" class="form-control input-lg descriptionBox"></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="col-12 submitButtonContainer">
                  <button type="submit" class="btn btn-default btn-lg track-btn submitButton">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
  </div>
</div>
  
<app-footer></app-footer>
 
